import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import Filters from "./Filterbtn";
import Table from "./Table";
import Pagination from "./Pagination";
import { GetMonazamDetails } from "../../../../../Actions/RequestActions";
import { FaChevronDown } from "react-icons/fa";
import "./BankDropdown.css";

const MainContent = ({ userType: propUserType }) => {
  const { userType: paramUserType } = useParams();
  const location = useLocation();
  const userType = propUserType || paramUserType;
  const isMonazam = userType === "monazam";
  
  const [selectedCurrency, setSelectedCurrency] = useState("PKR");
  const [selectedBankAccountId, setSelectedBankAccountId] = useState("");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [amount, setAmount] = useState(0);
  const [bankLoading, setBankLoading] = useState(false);
  const [bankError, setBankError] = useState("");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    setSelectedCurrency("PKR");
    setSelectedBankAccountId("");
  }, [location.pathname]);

  useEffect(() => {
    if (isMonazam) {
      GetMonazamDetails(
        (data) => {
          if (data?.bankAccounts && Array.isArray(data.bankAccounts)) {
            const pkrAccounts = data.bankAccounts.filter(acc => acc.accountType === "PKR");
            if (pkrAccounts.length > 0) {
              setBankAccounts(pkrAccounts);
              if (selectedCurrency === "PKR" && !selectedBankAccountId) {
                const defaultBank = pkrAccounts.find(acc => acc.isDefault === true) || pkrAccounts[0];
                setSelectedBankAccountId(defaultBank.id);
              }
            }
          }
        },
        setBankLoading,
        setBankError
      );
    }
  }, [isMonazam]);

  useEffect(() => {
    if (selectedCurrency === "PKR" && bankAccounts.length > 0 && !selectedBankAccountId) {
      const defaultBank = bankAccounts.find(acc => acc.isDefault === true) || bankAccounts[0];
      if (defaultBank) {
        setSelectedBankAccountId(defaultBank.id);
      }
    } else if (selectedCurrency === "USD") {
      setSelectedBankAccountId("");
    }
  }, [selectedCurrency, bankAccounts]);

  const handleCurrencySelect = (currency) => {
    setSelectedCurrency(currency);
  };

  const [bankDropdownOpen, setBankDropdownOpen] = useState(false);
  const bankDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (bankDropdownRef.current && !bankDropdownRef.current.contains(event.target)) {
        setBankDropdownOpen(false);
      }
    };

    if (bankDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [bankDropdownOpen]);

  const handleBankSelect = (accountId) => {
    setSelectedBankAccountId(accountId);
    setBankDropdownOpen(false);
  };

  const handleBankAccountsUpdate = (newBankAccounts) => {
    if (newBankAccounts && Array.isArray(newBankAccounts) && newBankAccounts.length > 0) {
      setBankAccounts(newBankAccounts);
      if (selectedCurrency === "PKR" && !selectedBankAccountId) {
        const defaultBank = newBankAccounts.find(acc => acc.isDefault === true) || newBankAccounts[0];
        if (defaultBank) {
          setSelectedBankAccountId(defaultBank.id);
        }
      }
    }
  };

  const selectedBankAccount = bankAccounts.find(acc => acc.id === selectedBankAccountId);

  return (
    <div className="container-fluid main-content-table bgColor d-flex flex-column overflow-hidden mt-2">
      <hr />
      

      <div className="flex-grow-1 d-flex flex-column me-3">
        <div className="d-flex justify-content-md-between items-center align-items-center">
          <div className="d-flex pt-3 mt-3">
            <Filters
              selectedCurrency={selectedCurrency}
              onCurrencySelect={handleCurrencySelect}
              className="my-2 fw-bold"
            />
          </div>
          
          <div className="d-flex align-items-center mt-3 mt-md-0 px-2 gap-2">
            {selectedCurrency === "PKR" && bankAccounts.length > 0 && (
                <div className="balance-box p-2 border-2 d-flex flex-column justify-content-center">
                  <div className="bank-dropdown-custom position-relative w-100 h-100" ref={bankDropdownRef}>
                    <div
                      className="bank-dropdown-selected"
                      onClick={() => setBankDropdownOpen(!bankDropdownOpen)}
                    >
                      {selectedBankAccount ? (
                        <>
                          <div className="bank-name-display">
                            {selectedBankAccount.bankName || 'Bank'}
                          </div>
                          <div className="bank-iban-display">
                            {selectedBankAccount.iban || selectedBankAccount.accountNumber || ''}
                          </div>
                        </>
                      ) : (
                        <div className="bank-name-display">Select Bank</div>
                      )}
                      <FaChevronDown className="bank-dropdown-arrow" />
                    </div>
                    {bankDropdownOpen && (
                      <div className="bank-dropdown-options">
                        {bankAccounts.map((account) => (
                          <div
                            key={account.id}
                            className={`bank-dropdown-option ${account.id === selectedBankAccountId ? 'selected' : ''}`}
                            onClick={() => handleBankSelect(account.id)}
                          >
                            <div className="bank-dropdown-option-name">
                              {account.bankName || 'Bank'}
                            </div>
                            <div className="bank-dropdown-option-iban">
                              {account.iban || account.accountNumber || ''}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
              
              <div className="balance-box p-2 border-2 d-flex flex-column justify-content-center">
              <div>
                <div className="balance-txt">Balance</div>
                <div className="amount-txt fw-bold">
                  {selectedCurrency === "PKR"
                    ? `PKR ${amount.toLocaleString()}`
                    : `USD ${amount.toLocaleString()}`}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div
          className="table-wrapper flex-grow-1 p-3 rounded shadow-sm d-flex flex-column"
        >
          <div className="table-container scroll flex-grow-1">
              <Table
                setAmount={setAmount}
                currency={selectedCurrency}
                bankAccountId={selectedCurrency === "PKR" ? selectedBankAccountId : undefined}
                setBankAccounts={handleBankAccountsUpdate}
                isMonazam={isMonazam}
              />
          </div>

          <div className="pagination-container mt-2 me-3">
            <Pagination />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
